<a [routerLink]="['/individual', individualId]">
  <div class="name">{{ name }}</div>
</a>
